import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommunityDetailsComponent } from './pages/community-details/community-details.component';
import { CommunityListComponent } from './pages/community-list/community-list.component';
import { CommunityComponent } from './community.component';
import { ViewCommunityComponent } from './pages/view-community/view-community.component';

const routes: Routes = [
  {
    component: CommunityComponent,
    path: '',
    children: [
      { path: '', component: CommunityListComponent },
      { path: 'new', component: CommunityDetailsComponent },
      { path: 'community-details/:id', component: CommunityDetailsComponent },
      { path: 'community-view/:id', component: ViewCommunityComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommunityRoutingModule {}
